import throttle from 'lodash-es/throttle.js';
import getRemBase from 'propel/getRemBase';
import { showWithFade, hideWithFade } from 'propel/fadeToggle';

const propelInit = function() {
const SUBMENU_CLASSES = {
	displayClass: 'block-nav-submenu--visible',
	openClass: 'block-nav-submenu--open',
};

const HEADER_CLASSES = {
	displayClass: 'block-nav-submenu__header--visible',
	openClass: 'block-nav-submenu__header--open',
};

const navBackButtons = document.querySelectorAll(
	'.block-nav-submenu__back-button'
);

const clickNavBackButton = (e) => {
	const currentNavBackButton = e.currentTarget;
	const navLink = currentNavBackButton.closest('.block-nav-link');

	if (!navLink) {
		return;
	}

	navLink.classList.remove('active');

	const navLinkButton = navLink.querySelector(
		'.block-nav-link__button--with-submenu'
	);

	navLinkButton?.setAttribute('aria-expanded', false);

	const closeEvent = new CustomEvent('propel-nav-submenu-closed', {
		detail: { currentElement: navLinkButton ?? navLink },
	});

	window.dispatchEvent(closeEvent);
};

const setMenuOffset = (navSubMenu) => {
	if (!navSubMenu) {
		return;
	}

	navSubMenu.style.setProperty('--submenuOffset', `0rem`);

	const navSubMenuRect = navSubMenu.getBoundingClientRect();

	if (0 === navSubMenuRect.width || !navSubMenuRect.x) {
		return;
	}

	const navSubMenuLeft = navSubMenuRect.x;
	const navSubMenuRight = navSubMenuRect.x + navSubMenuRect.width;
	const navBlock = navSubMenu.closest('.block-nav-header');
	let navBlockWidth = window.innerWidth;

	if (navBlock) {
		const navBlockStyles = window.getComputedStyle(navBlock);

		navBlockWidth =
			navBlock.offsetWidth -
			parseFloat(navBlockStyles['padding-left']) -
			parseFloat(navBlockStyles['padding-right']);
	}

	const containerLeft = (window.innerWidth - navBlockWidth) / 2;
	const containerRight = containerLeft + navBlockWidth;
	let offset = 0;

	if (navSubMenuLeft < containerLeft) {
		offset = containerLeft - navSubMenuLeft;
	} else if (navSubMenuRight > containerRight) {
		offset = containerRight - navSubMenuRight;
	}

	navSubMenu.style.setProperty(
		'--submenuOffset',
		`${offset / getRemBase()}rem`
	);
};

const setActiveMenuOffsets = () => {
	document
		.querySelectorAll('.block-nav-link.active .block-nav-submenu')
		.forEach(setMenuOffset);
};

const openMenu = (navLink) => {
	const navSubMenu = navLink?.querySelector('.block-nav-submenu');

	const navSubMenuHeader = navLink?.querySelector(
		'.block-nav-submenu__header'
	);

	if (!navSubMenu) {
		return;
	}

	showWithFade(navSubMenu, SUBMENU_CLASSES, () => setMenuOffset(navSubMenu));
	showWithFade(navSubMenuHeader, HEADER_CLASSES);
};

const closeMenu = (navSubMenu) => {
	hideWithFade(navSubMenu, SUBMENU_CLASSES);

	const navSubMenuHeader = navSubMenu
		.closest('.block-nav-link')
		?.querySelector('.block-nav-submenu__header');

	hideWithFade(navSubMenuHeader, HEADER_CLASSES);
};

// Switching directly from one open submenu to another only dispatches an "opened" event for
// the new one — the previous link's .active class is removed without a matching "closed" event.
// Reconciling against the DOM (rather than trusting which link an event names) catches that case.
const closeInactiveMenus = () => {
	document
		.querySelectorAll('.block-nav-submenu--open')
		.forEach((navSubMenu) => {
			if (!navSubMenu.closest('.block-nav-link.active')) {
				closeMenu(navSubMenu);
			}
		});
};

const setOpenedMenuOffset = (e) => {
	const navLink = e?.detail?.currentElement?.closest('.block-nav-link');

	openMenu(navLink);
	closeInactiveMenus();
};

navBackButtons.forEach((navBackButton) => {
	navBackButton.addEventListener('click', clickNavBackButton);
});

window.addEventListener('propel-nav-submenu-opened', setOpenedMenuOffset);
window.addEventListener('propel-nav-submenu-closed', closeInactiveMenus);
window.addEventListener('resize', throttle(setActiveMenuOffsets, 100));
window.addEventListener('propel-rem-base-updated', setActiveMenuOffsets);

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['nav-submenu'] = window.propel.blocks['nav-submenu'] || {};
window.propel.blocks['nav-submenu'].script = propelInit;
